module.exports = __webpack_public_path__ + "img/confernote_01.31ee202d.png";